import React from 'react'
import { useSelector } from 'react-redux'

import { resetMapEventPopin } from '../../store/map/map.actions'
import { selectMapEventPopin, selectShouldDisplayMapEventPopin } from '../../store/map/map.selectors'
import cross from '../genericComponents/assets/cross.svg'
import { withMapReady } from '../map/map.utils'
import SVGIcon from '../svg/SVGIcon'
import { useAction } from '../utils/react-redux'
import useEventCallback from '../utils/useEventCallback'
import s from './MapEventPopin.less'

const MapEventPopin = () => {
  const mapEventPopinInfo = useSelector(selectMapEventPopin)
  const shouldDisplayMapEvenPopin = useSelector(selectShouldDisplayMapEventPopin)
  const execResetMapEventPopinInfo = useAction(resetMapEventPopin)

  const onClick = useEventCallback(execResetMapEventPopinInfo, [execResetMapEventPopinInfo])

  if (!mapEventPopinInfo || !shouldDisplayMapEvenPopin) return <></>

  const { title, description, asset_zone, asset_event } = mapEventPopinInfo

  return (
    <div className={s.container}>
      <SVGIcon url={asset_zone} className={s.asset} />
      <div className={s.textContainer}>
        <SVGIcon url={asset_event} className={s.logo} />
        <span className={s.title}>{title}</span>
        <span className={s.description}>{description}</span>
      </div>
      <div className={s.closeButton} onClick={onClick}>
        <SVGIcon url={cross} />
      </div>
    </div>
  )
}

export default withMapReady(MapEventPopin)
